<template>
  <div class="footer">
    <!--    <div class="links">-->
    <!--      <a-->
    <!--        href="https://pro.loacg.com/"-->
    <!--        target="_blank"-->
    <!--      >Pro 首页</a>-->
    <!--      <a-->
    <!--        href="https://github.com/sendya/ant-design-pro-vue"-->
    <!--        target="_blank"-->
    <!--      >-->
    <!--        <a-icon type="github"/>-->
    <!--      </a>-->
    <!--      <a href="https://ant.design/">Ant Design</a>-->
    <!--      <a href="https://vue.ant.design/">Vue Antd</a>-->
    <!--    </div>-->
    <div class="copyright">
      <!--      {{platformInfo.copyText}}-->
      <span>{{ platformInfo.copyText }}</span>
      <a class='active' :href="platformInfo.officialUrl" target="_blank"
         style='margin-left: 10px'>{{ platformInfo.technicalSupport }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalFooter',
  data() {
    return {
      platformInfo: {}
    }
  },
  mounted() {
    this.platformInfo = this.getPlatformConfig()
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.footer {
  padding: 16px;
  margin: 24px 0;
  text-align: center;

  .links {
    margin-bottom: 8px;

    a {
      color: rgba(0, 0, 0, 0.45);

      &:hover {
        color: rgba(0, 0, 0, 0.65);
      }

      &:not(:last-child) {
        margin-right: 40px;
      }
    }
  }

  .copyright {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}
</style>
